App.addModule(function(app) {

    if (!app.getConfigFlag('meta/tracking/active') || !app.getConfig('meta/tracking/account') || !app.get('customer.can_track')) {
        return
    }

    app.onConsent('performance', () => {
        
        window.fbq = function() {
            fbq.callMethod ? fbq.callMethod.apply(n, arguments) : fbq.queue.push(arguments)
        }
        
        fbq.loaded = true
        fbq.version = '2.0'
        fbq.queue = []

        window._fbq = fbq

        app.loadScript('https://connect.facebook.net/en_US/fbevents.js')

        fbq('init', app.getConfig('meta/tracking/account'))

        fbq('track', 'PageView');

        const order = app.get('checkout.order')

        if (order) {
            fbq('track','Purchase',{
			    value: app.round(order.base_subtotal, 2),
			    currency: order.base_currency_code
		    })
        }
    })
})
